import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Perfil } from 'src/app/model/perfil';
import { PerfilService } from 'src/app/service/perfil.service';

@Component({
  selector: 'app-perfil-consulta',
  templateUrl: './perfil-consulta.component.html',
  styleUrls: [
    './perfil.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class PerfilConsultaComponent {

  perfis: Perfil[] = [];
  ordemColunasTabela = ['id', 'nome', 'descricao', 'ativo', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  tipoFiltros: string[] = ['ID', 'Nome'];
  tipoFiltro = 'ID';
  parametro = '';
  consultaRealizada = false;

  constructor(
    private snackBar: MatSnackBar,
    private perfilService: PerfilService,
    private router: Router,
  ) { }

  novo() {
    this.router.navigate(['/perfil/form']);
  }

  editar(id: number) {
    this.router.navigate(['/perfil/form', id]);
  }

  listarPerfisAtivos() {
    this.perfilService.buscarPerfisAtivo().subscribe((response) => {
      this.perfis = response;
      this.totalElementos = response.length;
      this.consultaRealizada = true;
    });
  }

  paginar(event: any) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  consultar(resetPagina = true) {
    if (resetPagina) {
      this.pagina = 0;
    }

    if (this.parametro?.trim()) {
      this.perfilService.buscar(this.pagina, this.parametro, this.tamanho, this.tipoFiltro).subscribe((response) => {
        this.perfis = response.content;
        this.totalElementos = response.totalElements;
        this.pagina = response.number;
        this.consultaRealizada = true;
      });
    } else {
      this.listarPerfisAtivos();
    }
  }
}
